<template>
  <div>
    <h2 class="title">{{ adminText('workflowsAll.general_info_b0fe391', 'General info') }}</h2>
    <general-info-form
      :initial-values="form"
      :vs="vs"
      :categories="categories"
      @values="form = $event"
    />
    <div>
      <h2 class="title additional-title">{{ adminText('workflowsAll.additional_info_e173235', 'Additional info') }}</h2>
      <p class="description">
        {{ adminText('workflowsAll.this_information_is_optional_if_you_decide_to_b2f854e', 'This information is optional. If you decide to skip it, you can edit at any moment under your event settings.') }}
      </p>
    </div>
    <cover-field
      id="event-cover-field"
      v-model="form.cover"
      tabindex="-1"
      @upload-in-progress="uploadInProgress = $event"
    />
    <v-layout class="pb-16">
      <v-flex class="pr-30" xs12>
        <text-field
          v-model.trim="form.metadata.facebookLink"
          :validator="vs.metadata.facebookLink"
          :label="adminText('workflowsAll.facebook_link_197bd42', 'Facebook link')"
        />
      </v-flex>
      <v-flex xs12>
        <text-field
          v-model.trim="form.metadata.webLink"
          :validator="vs.metadata.webLink"
          :label="adminText('workflowsAll.website_2e8a57c', 'Website')"
        />
      </v-flex>
    </v-layout>
    <text-editor-field
      v-model="form.description"
      :placeholder="adminText('workflowsAll.description_55f8ebc', 'Description')"
      :validator="vs.description"
      image-and-code-block-enabled
    />
    <p class="text-field-description">{{ adminText('workflowsAll.description_will_be_visible_on_the_event_page_0464b88', 'Description will be visible on the event page') }}</p>
    <h2 class="title">{{ adminText('workflowsAll.highlighted_information_optional_331b68a', 'Highlighted information (optional)') }}</h2>
    <p class="description">
      {{ adminText('workflowsAll.add_useful_information_about_your_event_like__5524d77', 'Add useful information about your event (like age limit, table reservation, etc.)') }}
    </p>
    <highlights-form :initial-values="form" :vs="vs" @values="form = $event" />
    <h2 class="title">{{ adminText('workflowsAll.frequently_asked_questions_optional_c238d97', 'Frequently Asked Questions (optional)') }}</h2>
    <p class="description">
      {{ adminText('workflowsAll.add_frequently_asked_questions_about_your_eve_c07d372', 'Add frequently asked questions about your event. This will be displayed on the landing page of your event.') }}
    </p>
    <faq-form :initial-values="form" :vs="vs" @values="form = $event" />
    <div v-if="showButtons" class="buttons-wrapper">
      <main-button class="back-btn" flat :text="adminText('workflowsAll.cancel_1507c40', 'CANCEL')" @click="goBack()" />
      <div class="buttons">
        <main-button
          class="continue-btn"
          depressed
          color="#0277BD"
          flat
          :outline="true"
          @click="() => this.$emit('back')"
        >
          <v-icon class="arrow-back">arrow_back</v-icon>
          <span>{{ adminText('workflowsAll.back_61bb8d2', 'back') }}</span>
        </main-button>
        <main-button
          :disabled="uploadInProgress || !isFormValid"
          class="continue-btn"
          depressed
          @click="() => this.$emit('next')"
        >
          <span>{{ adminText('workflowsAll.continue_eee0bbb', 'continue') }}</span>
          <v-icon class="arrow">arrow_forward</v-icon>
        </main-button>
      </div>
    </div>
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import FaqForm from './faq-form.vue'
import GeneralInfoForm from './general-info-form.vue'
import HighlightsForm from './highlights-form.vue'

export default {
  mixins: [WorkflowDisplay],
  name: 'event-info-form',
  components: {
    GeneralInfoForm,
    HighlightsForm,
    FaqForm,
  },
  props: {
    initialValues: {
      type: Object,
      default: () => {
      },
    },
    categories: {
      type: Array,
      default: () => [],
    },
    vs: {
      type: Object,
      default: () => {
      },
    },
    showButtons: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      form: this.initialValues,
      uploadInProgress: false,
    }
  },
  computed: {
    isFormValid() {
      return !this.vs.$invalid && !this.vs.$error
    },
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('values', val)
      },
      deep: true,
    },
  },
  async mounted() {
    const targetId = window.location.hash
    if (targetId) {
      await this.$nextTick()
      this.scrollToElement(targetId)
    }
  },
  methods: {
    scrollToElement(id) {
      const target = document.querySelector(id)
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' })
        target.focus({ preventScroll: true })
      }
    },
  },
}
</script>

<style>
.mln-32 {
  margin-left: -2rem !important;
}

.title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-bottom: 1.5rem;
}

.additional-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-bottom: 1.5rem;
  margin-top: 1.5rem;
}

.description {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 1.125rem;
  color: #979797;
  margin-bottom: 1.5rem;
}

.buttons-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

@media screen and (max-width: 444px) {
  .buttons-wrapper {
    flex-direction: column-reverse;
  }

  .buttons {
    display: flex;
    flex-direction: column-reverse;
  }
}

.text-field-description {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1rem;
  color: #666666;
  margin-bottom: 1.5rem;
  margin-top: -1.875rem;
  margin-left: 0.875rem;
}

.arrow {
  margin-left: 0.625rem;
}

.arrow-back {
  margin-right: 0.625rem;
}

.textFieldDescription {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1rem;
  color: #666666;
  margin-bottom: 1.5rem;
  margin-top: -0.875rem;
  margin-left: 0.875rem;
}
</style>
